import type * as React from 'react';
import { type FC, Fragment } from 'react';

import CheckNew from '@crehana/icons/CheckNew';
import { white } from '@crehana/ui/dist/styles/colors';
import { clsx } from 'clsx';

interface OnboardingStepsProps {
  currentStep: number;
  className?: string;
  steps: {
    id: number;
    label: string;
  }[];
}

const Steps: FC<React.PropsWithChildren<OnboardingStepsProps>> = ({
  currentStep,
  className,
  steps,
}) => (
  <div className={clsx('flex items-center justify-between', className)}>
    {steps.map((step, idx) => (
      <Fragment key={step.id}>
        <div className="flex items-center">
          <div className="flex flex-col sm:flex-row items-center">
            <div
              className={clsx(
                'sm:mr-12 min-w-24 min-h-24 flex items-center justify-center rounded-full mb-8 sm:mb-0',
                currentStep >= step.id ? 'bg-primary-main' : 'bg-gray-main',
              )}
            >
              {step.id < currentStep ? (
                <CheckNew color={white} size={16} />
              ) : (
                <p className="font-subtitle4 text-white">{idx + 1}</p>
              )}
            </div>
            <p
              className={clsx(
                'font-subtitle4 text-center h-36 sm:h-auto',
                currentStep === step.id ? 'text-base-main' : 'text-gray-main',
              )}
            >
              {step.label}
            </p>
          </div>
        </div>
        {idx + 1 !== steps.length && (
          <div className="border border-solid border-gray-main w-24 h-0 mx-auto" />
        )}
      </Fragment>
    ))}
  </div>
);

export default Steps;
